import { Injectable } from '@angular/core';

import { MwService } from '~app/shared/services/mw/mw.service';
import { environment } from '~env';
import { Profile } from '../models/profile.model';
import { DataUtilsService } from '../services/data-utils/data-utils.service';
import { StoreService } from '../services/store/store.service';
import { UserService } from '../services/user/user.service';

@Injectable()
export class ProfileResolver {
  constructor(
    private readonly mw: MwService,
    private readonly store: StoreService,
    private readonly dataUtils: DataUtilsService,
    private readonly userService: UserService,
  ) {}

  public async resolve(): Promise<any> {
    await this.dataUtils.ensureCountries();
    const user = this.store.currentUser;

    if (!user.profile) {
      const profileData = await this.mw.getCrewMemberProfile().toPromise();
      const profile = new Profile(profileData.payload, this.store.countries);
      user.profile = profile;
    }

    if (environment.featureFlags.crewPhoto) {
      await this.userService.loadCrewPhoto(user);
    }

    return user.profile;
  }
}
